import Reactor from 'data/reactor';
import Getters from 'data/getters';
import StudentGetters from 'data/student/getters';

import GlobalChartUtils from './chart';
import { Immutable } from 'nuclear-js';

const getSeriesData = (dataPoints) => {
    if (!dataPoints || !dataPoints.studentBid) {
        return null;
    }
    const termData = Reactor.evaluate(StudentGetters.termDataForStudentBid(dataPoints.studentBid));
    const chartCenteredTerm =
        dataPoints.isMostRecentTerm && dataPoints.currentTerm
            ? dataPoints.currentTerm.get('termNumber')
            : dataPoints.selectedTermNumber;
    const termList = GlobalChartUtils.findTermsForGOTChart(chartCenteredTerm);
    GlobalChartUtils.addGradeAndWeeksToGOTTerms(dataPoints.terms, termData, termList);

    const xAxisTermNames = GlobalChartUtils.populateCategoryNames(termList);

    // NOTE: No need to update 'dataPoints.subject' to be MSID since this function is only called in GOT and Batch Print
    //       These areas don't present a course-specific chart.
    const quintiles = GlobalChartUtils.findRitQuintilesForChart(termData, dataPoints.subject, dataPoints.ritQuintiles);
    const ritQuintilesForChart = GlobalChartUtils.populateRitQuintileSeries(termList, quintiles);
    const typicalScoreSeries = GlobalChartUtils.populateTypicalScoreSeries(termList, quintiles);
    const RITSeries = GlobalChartUtils.populateRITScoreSeries(
        termList,
        dataPoints.subject.get('bid'),
        dataPoints.testEvents.valueSeq(),
        quintiles
    );

    const growthGoalSeries = GlobalChartUtils.populateGoalSeries(termList, dataPoints.growthGoals);
    const testToProjectFrom = GlobalChartUtils.findTestToProjectFrom(dataPoints.testEvents, dataPoints.currentTerm);
    const growthProjections = Reactor.evaluate(
        StudentGetters.growthProjectionsForStudentBidAndSubjectBid(dataPoints.studentBid, dataPoints.subject.get('bid'))
    );
    const projectionsSeries = GlobalChartUtils.populateProjectionSeries(termList, testToProjectFrom, growthProjections);

    const districtAverages = Reactor.evaluate(Getters.partner.districtAverages);
    const districtAveragesForTermList = GlobalChartUtils.findDistrictAveragesForChart(
        termList,
        dataPoints.subject,
        districtAverages
    );
    const districtAveragesSeries = GlobalChartUtils.populateDistrictAveragesSeries(
        termList,
        districtAveragesForTermList
    );

    return {
        xAxisTermNames,
        ritQuintilesForChart,
        typicalScoreSeries,
        RITSeries,
        growthGoalSeries,
        projectionsSeries,
        districtAveragesSeries,
    };
};

const getFamilyGOTChartSeriesData = (dataPoints) => {
    if (!dataPoints || !dataPoints.studentBid) {
        return null;
    }
    const termData = Reactor.evaluate(StudentGetters.termDataForStudentBid(dataPoints.studentBid));
    const familyTermList = GlobalChartUtils.findTermsForGOTChart(
        dataPoints.isMostRecentTerm && dataPoints.currentTerm
            ? dataPoints.currentTerm.get('termNumber')
            : dataPoints.selectedTermNumber,
        true
    );
    const courseCompatibleSubject = Immutable.Map({ bid: dataPoints.measurementScaleID });
    const quintiles = GlobalChartUtils.findRitQuintilesForChart(
        termData,
        courseCompatibleSubject,
        dataPoints.ritQuintiles
    );
    const typicalScoreSeries = GlobalChartUtils.populateTypicalScoreSeries(familyTermList, quintiles, true);
    const familyRITSeries = GlobalChartUtils.populateRITScoreSeries(
        familyTermList,
        dataPoints.subject.get('bid'),
        dataPoints.testEvents.valueSeq(),
        null,
        dataPoints.measurementScaleID,
        true
    );

    const xAxisTermNames = GlobalChartUtils.populateCategoryNames(familyTermList, true);

    return {
        xAxisTermNames,
        familyRITSeries,
        typicalScoreSeries,
    };
};

export default {
    getSeriesData,
    getFamilyGOTChartSeriesData,
};
